export default "__VITE_ASSET__0TxrOGR$__"